import * as React from 'react';
import { UIHeading2 } from '@cian/ui-kit';

import { INewbuildingsCompareCard } from '../../hooks/useCompareCards';
import * as style from '../../style.css';
import { CompareRow } from '../CompareRow';
import { TitleIcon } from '../../TitleIcon';

export interface ICompareCardProps {
  card: INewbuildingsCompareCard;
  pinnedIndex: number | null;
  registerCell(id: string): (node: HTMLDivElement | null) => void;
}

export const CompareCard = ({ card, pinnedIndex, registerCell }: ICompareCardProps) => {
  const icon = card.header?.imagePath;

  return (
    <div className={style['card']} data-testid="newbuildings-compare-mobile_card" role="rowgroup">
      <div className={style['card-content']} role="presentation">
        {card.header && (
          <div className={style['block-row']} role="row">
            {icon && (
              <span className={style['block-icon']}>
                <TitleIcon icon={icon} />
              </span>
            )}
            <UIHeading2>{card.header.title}</UIHeading2>
          </div>
        )}
        {card.rows.map(row => (
          <CompareRow key={row.key} pinnedIndex={pinnedIndex} registerCell={registerCell} row={row} />
        ))}
      </div>
    </div>
  );
};
